import { render } from "./recommend.vue?vue&type=template&id=6fdeb07e&scoped=true"
import script from "./recommend.vue?vue&type=script&lang=js"
export * from "./recommend.vue?vue&type=script&lang=js"

import "./recommend.vue?vue&type=style&index=0&id=6fdeb07e&scoped=true&lang=css"

import exportComponent from "/Users/jiangxin/xhw/outer-h5-gwj-nft-website-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdeb07e"]])

export default __exports__